import styles from './LoginForm.module.scss'
import { PATTERNS } from '@/constants'
import cn from 'classnames'
import { useRouter } from 'next/router'
import { useState } from 'react'
import Button from '@/components/Button'
import Input from '@/components/Input'
import AuthService from '@/services/AuthService'

const isDevEnv = process.env.NODE_ENV === 'development'
const prefillForm = true

function LoginForm({ className, redirectUrl = null, ...props }) {
  const router = useRouter()
  const [loading, setLoading] = useState(false)
  const [errors, setErrors] = useState([])

  async function handleSubmit(event) {
    event.preventDefault()

    const form = event.currentTarget
    const formData = new FormData(form)

    try {
      setLoading(true)

      const response = await AuthService().login(JSON.stringify(Object.fromEntries(formData)))
      const data = await response.json()

      if (data?.errors) return setErrors(data.errors)
      if (!response.ok) throw response.statusText

      redirectUrl ? router.push(redirectUrl) : router.reload()
    } catch (error) {
      throw new Error(error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <form
      className={cn(styles['root'], { [className]: className })}
      onSubmit={(event) => handleSubmit(event)}
      noValidate
      {...props}
    >
      <Input.Box className={styles['input-box']}>
        <Input.Label>E-mailadres</Input.Label>

        <Input
          name="email"
          type="email"
          placeholder="E-mailadres"
          pattern={PATTERNS.email}
          {...(isDevEnv && prefillForm && { defaultValue: 'ilse@kinderopvang.nl' })}
          required
          errorMessage={errors?.email}
        />

        <Input.Error />
      </Input.Box>

      <Input.Box className={styles['input-box']}>
        <Input.Label>Wachtwoord</Input.Label>

        <Input
          name="password"
          type="password"
          placeholder="Wachtwoord"
          {...(isDevEnv && prefillForm && { defaultValue: '@123temp_password456!' })}
          required
          errorMessage={errors?.password}
        />

        <Input.Error />
      </Input.Box>

      <Input.Box className={styles['input-box--checkbox']}>
        <Input
          name="remember"
          type="checkbox"
          {...(isDevEnv && prefillForm && { defaultChecked: true })}
        />

        <Input.Label>Ingelogd blijven</Input.Label>
      </Input.Box>

      <Button
        type="submit"
        color="yellow"
        loading={loading}
      >
        Inloggen
      </Button>
    </form>
  )
}

export default LoginForm
